<template>
    <form class="form-signin" @submit.prevent="submit">
        <div class="login-card">
            <header class="login-header">
                <img class="login-logo" width="200" src="/images/logo-lead.png" :alt="themeBrandName" />
                <div class="login-heading-row">
                    <div>
                        <h5 class="login-title">Modifier mon mot de passe</h5>
                    </div>
                    <ChooseLang class="login-lang" />
                </div>
            </header>

            <loader-component v-if="loading" class="login-loader" />

            <div class="alert alert-warning login-alert">
                Pour des raisons de sécurité, vous devez modifier votre mot de passe avant de continuer.
            </div>
            <div v-if="errorMessage" class="alert alert-danger login-alert">
                {{ errorMessage }}
            </div>

            <template v-if="!loading">
                <div class="login-fields">
                    <div class="login-field">
                        <label for="current_password" class="form-label login-label">{{ $tl("labels.form.oldPassword") }}</label>
                        <CurrentPasswordInputComponent
                            id="current_password"
                            v-model="currentPassword"
                            :inputClass="{ 'is-invalid': hasErrors('current_password') }"
                            required
                            @input="clearErrors('current_password')" />
                        <div
                            v-if="hasErrors('current_password')"
                            class="invalid-feedback d-block"
                            role="alert"
                            v-html="joinErrors('current_password')"></div>
                    </div>

                    <div class="login-field">
                        <label for="password" class="form-label login-label">{{ $tl("labels.form.newPassword") }}</label>
                        <PasswordInputComponent id="password" v-model="password" required @input="clearPasswordErrors" />
                        <div v-if="hasErrors('password')" class="invalid-feedback d-block" role="alert" v-html="joinErrors('password')"></div>
                    </div>

                    <div class="login-field">
                        <label for="password_confirmation" class="form-label login-label">{{ $tl("labels.form.newPasswordConfirm") }}</label>
                        <PasswordConfirmationInputComponent
                            id="password_confirmation"
                            :mainPassword="password"
                            v-model="passwordConfirmation"
                            required
                            @input="clearErrors('password_confirmation')" />
                        <div
                            v-if="hasErrors('password_confirmation')"
                            class="invalid-feedback d-block"
                            role="alert"
                            v-html="joinErrors('password_confirmation')"></div>
                    </div>
                </div>

                <button type="submit" class="btn btn-success btn-circle login-submit">
                    {{ $tl("labels.form.changePassword") }}
                </button>
            </template>
        </div>
    </form>
</template>

<script>
import axios from "axios";
import ChooseLang from "../../components/Default/ChooseLang.vue";
import LoaderComponent from "../../components/LoaderComponent.vue";
import CurrentPasswordInputComponent from "../../components/forms/CurrentPasswordInputComponent.vue";
import PasswordConfirmationInputComponent from "../../components/forms/PasswordConfirmationInputComponent.vue";
import PasswordInputComponent from "../../components/forms/PasswordInputComponent.vue";

export default {
    name: "MandatoryPasswordChange",
    components: {
        ChooseLang,
        LoaderComponent,
        CurrentPasswordInputComponent,
        PasswordConfirmationInputComponent,
        PasswordInputComponent,
    },
    data() {
        return {
            loading: false,
            errorMessage: null,
            errors: {},
            currentPassword: "",
            password: "",
            passwordConfirmation: "",
        };
    },
    methods: {
        submit() {
            this.loading = true;
            this.errorMessage = null;
            this.errors = {};

            axios
                .put("/api/password/change", {
                    current_password: this.currentPassword,
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                })
                .then((response) => {
                    window.location.href = response.data.redirect_url || "/";
                })
                .catch((error) => {
                    if (error.response && error.response.data.message) {
                        this.errorMessage = error.response.data.message;
                    } else if (error.message) {
                        this.errorMessage = error.message;
                    }

                    this.errors = error.response && error.response.data.errors ? error.response.data.errors : {};
                    this.currentPassword = "";
                    this.password = "";
                    this.passwordConfirmation = "";
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        clearPasswordErrors() {
            this.clearErrors("password");
            this.clearErrors("password_confirmation");
        },
        clearErrors(field) {
            if (this.errors[field]) {
                this.$delete(this.errors, field);
            }
        },
        hasErrors(field) {
            return Array.isArray(this.errors[field]) && this.errors[field].length > 0;
        },
        joinErrors(field) {
            return this.hasErrors(field) ? this.errors[field].join("<br>") : "";
        },
    },
};
</script>
